import * as React from "react";

class Band extends React.Component {
  render() {
    return <div className="band">{this.props.children}</div>;
  }
}

export default Band;
